<template>
    <v-row justify="center">
      <v-dialog v-model="dialogPedidos" persistent max-width="600px" @click:outside="toggleDialogPedidos">
        <v-card>
          <v-card-title>
            <span class="headline">Meus Vouchers</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row v-if="meusPedidos.length == 0">Você ainda não possui um voucher ativo/liberado, caso tenha feito PIX aguarde alguns minutos para tentar novamente</v-row>
              <v-row>
                <v-col cols="6" v-for="(pedido, i) in meusPedidos" :key="i">
                  <v-card @click="abrirVoucher(pedido)">
                    #{{ pedido.id }} <br />
                    Voucher: {{ pedido.voucher }} <br />
                    Valor: {{ pedido.valor | fmtNumber }} <br />
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="toggleDialogPedidos()">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Pedidos',
  data: () => ({
    cpf: '',
  }),
  computed: {
    ...mapState(['dialogPedidos', 'meusPedidos'])
  },
  methods: {
    ...mapMutations(['toggleDialogPedidos']),
    ...mapActions(['getCPF', 'cadastrarVisitante', 'loginVisitante']),
    abrirVoucher(pedido) {
        window.open('/voucher/'+pedido.voucher);
    }
  }
}
</script>
